import axios from 'axios'
import store from '../store'
import router from '@/router'

// https://github.com/axios/axios#request-config
const userApi = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json'
})

userApi.interceptors.request.use((config) => {
  config.headers = { authorization: store.state.auth.token }
  store.dispatch('isLoading', true)
  return config
})

userApi.interceptors.response.use(
  (response) => {
    store.dispatch('isLoading', false)
    return response.data
  },
  (error) => {
    store.dispatch('isLoading', false)
    if (error.response.status === 401 || error.response.status === 403) {
      store.dispatch('authClear', {})
      router.push({ name: 'login', params: error.response.data })
    }
    if (error.response.status === 500) {
      router.push({ path: '/error' })
      return Promise.reject(error.response.data)
    }
    if (error.response.status === 503) {
      router.push({ path: '/maintenance' })
      return Promise.reject(error.response.data)
    }
    if (error.response.messages === undefined) {
      error.response.messages = []
    }
    return Promise.reject(error.response.data)
  })

export default userApi
